import { Container } from 'react-bootstrap';
import type { Member, TeamMatchPlayResults, CurrentRyderCupTeamMember, MemberSummary } from '../types/api.types';
import type { EnrichedMatchResult } from './head-to-head.utils';
import { MembersPanel } from './members-panel';
import { OpponentsPanel } from './opponents-panel';
import { ResultsHistoryPanel } from './results-history-panel';

interface HeadToHeadProps {
  lstMembers: Member[];
  memberEntities: Record<string, MemberSummary>;
  mapSinglesStrokeResults: Record<string | number, Record<string | number, TeamMatchPlayResults[]>>;
  latestRyderCupTeams: CurrentRyderCupTeamMember[];
  selectedMember: string | number | null;
  selectedOpponent: string | number | null;
  showLatestRyderCupOnly: boolean;
  selectedMemberName: string;
  player1Results: Record<string | number, TeamMatchPlayResults[]> | undefined;
  opponentIds: (string | number)[];
  latestRyderCupMemberIds: Set<string | number>;
  sortedMatchResults: EnrichedMatchResult[] | undefined;
  onMemberSelect: (id: string | number | null) => void;
  onOpponentSelect: (id: string | number | null) => void;
  onFilterChange: (value: boolean) => void;
}

export default function HeadToHead({
  lstMembers,
  memberEntities,
  mapSinglesStrokeResults,
  latestRyderCupTeams,
  selectedMember,
  selectedOpponent,
  showLatestRyderCupOnly,
  selectedMemberName,
  player1Results,
  opponentIds,
  latestRyderCupMemberIds,
  sortedMatchResults,
  onMemberSelect,
  onOpponentSelect,
  onFilterChange,
}: HeadToHeadProps) {
  return (
    <div>
      <Container fluid style={{ height: 'calc(100vh - 80px)' }}>
        <div style={{ height: '100%', display: 'flex', gap: '6px' }}>
          <MembersPanel
            members={lstMembers}
            selectedMember={selectedMember}
            onMemberSelect={onMemberSelect}
            showLatestRyderCupOnly={showLatestRyderCupOnly}
            onFilterChange={onFilterChange}
            latestRyderCupTeams={latestRyderCupTeams}
            mapSinglesStrokeResults={mapSinglesStrokeResults}
            isFilterDisabled={latestRyderCupMemberIds.size === 0}
          />
          <OpponentsPanel
            memberEntities={memberEntities}
            selectedMember={selectedMember}
            selectedOpponent={selectedOpponent}
            onOpponentSelect={onOpponentSelect}
            opponentIds={opponentIds}
            player1Results={player1Results}
            showLatestRyderCupOnly={showLatestRyderCupOnly}
            latestRyderCupTeams={latestRyderCupTeams}
          />
          <ResultsHistoryPanel
            selectedMember={selectedMember}
            sortedMatchResults={sortedMatchResults}
            selectedMemberName={selectedMemberName}
            memberEntities={memberEntities}
          />
        </div>
      </Container>
    </div>
  );
}
